module.exports = __webpack_public_path__ + "img/mapPicDiploma.353efe5.PNG";